"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vueTypes = _interopRequireDefault(require("ant-design-vue/es/_util/vue-types"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _ItemListStyle = _interopRequireDefault(require("./common/ItemListStyle1.vue"));
var _ItemListStyle2 = _interopRequireDefault(require("./common/ItemListStyle2.vue"));
var _util = require("@/utils/util");
var Icon = _interopRequireWildcard(require("./icon"));
var _article = require("@/api/article");
var PageApi = _interopRequireWildcard(require("@/api/page"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 禁止拖拽的组件
var undragList = ['service'];
var _default = exports.default = {
  props: {
    // 页面数据
    data: _vueTypes.default.object.def({}),
    // 当前选中的元素索引
    selectedIndex: _vueTypes.default.oneOfType([_vueTypes.default.number, _vueTypes.default.string]).def(0),
    // 左侧正在拖拽新增的组件类型
    draggingNewType: _vueTypes.default.string.def('')
  },
  components: {
    draggable: _vuedraggable.default,
    itemListStyle1: _ItemListStyle.default,
    itemListStyle2: _ItemListStyle2.default
  },
  data: function data() {
    return {
      // 禁止拖拽的组件
      undragList: undragList,
      previewGoodsMap: {},
      previewArticleMap: {},
      previewRefreshTimer: null,
      dragInsertIndex: -1,
      phoneWidth: 377,
      phoneHeight: 812
    };
  },
  computed: {
    phoneContentStyle: function phoneContentStyle() {
      return {
        background: this.data.page.style.backgroundColor,
        width: "".concat(this.phoneWidth, "px"),
        height: "".concat(this.phoneHeight, "px")
      };
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler: function handler() {
        this.scheduleRefreshPreviewData();
      }
    }
  },
  beforeCreate: function beforeCreate() {
    this.Icon = Icon;
    this.inArray = _util.inArray;
  },
  mounted: function mounted() {
    this.updatePhoneSize();
    window.addEventListener('resize', this.updatePhoneSize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.updatePhoneSize);
    if (this.previewRefreshTimer) {
      clearTimeout(this.previewRefreshTimer);
      this.previewRefreshTimer = null;
    }
  },
  methods: {
    updatePhoneSize: function updatePhoneSize() {
      var nextHeight = Math.max(320, window.innerHeight - 150);
      var nextWidth = Math.round(nextHeight * (375 / 812) * 0.93);
      this.phoneHeight = nextHeight;
      this.phoneWidth = nextWidth;
    },
    /**
     * 拖动diy元素更新当前索引
     * @param e
     */
    handelDragItem: function handelDragItem(e) {
      this.$emit('onEditer', e.newIndex);
    },
    getItemsHeight: function getItemsHeight() {
      var _this = this;
      var tabListTop = 0;
      this.data.items.forEach(function (item) {
        if (item.type === 'tabList') {
          return;
        }
        var element = _this.$el.querySelector(".diy-" + item.type);
        console.log(element.clientHeight);
        tabListTop += element.clientHeight;
      });
      console.log("top:" + tabListTop);
    },
    /**
     * 点击当前选中的Diy元素
     * @param index
     */
    handelClickItem: function handelClickItem(index) {
      this.$emit('onEditer', index);
    },
    /**
     * 删除当前选中的Diy元素
     * @param index
     */
    handleDeleleItem: function handleDeleleItem(index) {
      this.$emit('onDeleleItem', index);
    },
    handleCopyItem: function handleCopyItem(index) {
      this.$emit('onCopyItem', index);
    },
    handleDragOver: function handleDragOver(event) {
      if (!this.draggingNewType) return;
      var items = this.$el ? this.$el.querySelectorAll('.devise-item') : [];
      if (!items || !items.length) {
        this.dragInsertIndex = 0;
        return;
      }
      var clientY = event.clientY;
      var insertIndex = this.data.items.length;
      for (var i = 0; i < items.length; i++) {
        var rect = items[i].getBoundingClientRect();
        if (clientY < rect.top + rect.height / 2) {
          insertIndex = i;
          break;
        }
      }
      this.dragInsertIndex = insertIndex;
      if (event && event.dataTransfer) {
        event.dataTransfer.dropEffect = 'copy';
      }
    },
    handleDragLeave: function handleDragLeave(event) {
      var target = event && event.relatedTarget;
      if (!this.$el || target && this.$el.contains(target)) return;
      this.dragInsertIndex = -1;
    },
    handleDropNewItem: function handleDropNewItem(event) {
      if (!this.draggingNewType) return;
      var insertIndex = this.dragInsertIndex > -1 ? this.dragInsertIndex : this.data.items.length;
      this.$emit('onDropNewItem', {
        type: this.draggingNewType,
        index: insertIndex
      });
      this.dragInsertIndex = -1;
    },
    // 渲染组件外层容器的样式
    renderItemStyle: function renderItemStyle(item) {
      if (item.type === 'service') {
        return {
          position: 'absolute',
          right: item.style.right + '%',
          bottom: item.style.bottom + '%'
        };
      }
      return {};
    },
    scheduleRefreshPreviewData: function scheduleRefreshPreviewData() {
      var _this2 = this;
      if (this.previewRefreshTimer) {
        clearTimeout(this.previewRefreshTimer);
      }
      this.previewRefreshTimer = setTimeout(function () {
        _this2.refreshPreviewData();
      }, 220);
    },
    refreshPreviewData: function refreshPreviewData() {
      var _this3 = this;
      var items = this.data && Array.isArray(this.data.items) ? this.data.items : [];
      items.forEach(function (item, index) {
        if (item.type === 'goods') {
          _this3.fetchGoodsPreview(index, item);
        } else if (item.type === 'article' || item.type === 'tabList' || item.type === 'stickyTabList') {
          _this3.fetchArticlePreview(index, item);
        }
      });
    },
    fetchGoodsPreview: function fetchGoodsPreview(index, item) {
      var _this4 = this;
      if (!item || !item.params) return;
      if (item.params.source === 'choice') {
        this.$set(this.previewGoodsMap, index, this.normalizeGoodsRows(item.data || []));
        return;
      }
      var auto = item.params.auto || {};
      var query = {
        bizType: Number(auto.bizType || 1),
        category: auto.category && Number(auto.category) > 0 ? Number(auto.category) : null,
        goodsSort: auto.goodsSort || 'all',
        showNum: auto.showNum || 6
      };
      PageApi.previewGoods(query).then(function (res) {
        var list = res && res.data && Array.isArray(res.data) ? res.data : [];
        _this4.$set(_this4.previewGoodsMap, index, _this4.normalizeGoodsRows(list));
      }).catch(function () {
        _this4.$set(_this4.previewGoodsMap, index, _this4.normalizeGoodsRows(item.data || item.defaultData || []));
      });
    },
    normalizeGoodsRows: function normalizeGoodsRows() {
      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return rows.map(function (row) {
        return {
          goods_name: row.goods_name || row.storeName || '',
          goods_image: row.goods_image || row.image || '',
          goods_price_min: row.goods_price_min || row.price || 0,
          line_price_min: row.line_price_min || row.otPrice || 0,
          selling_point: row.selling_point || row.storeInfo || '',
          goods_sales: row.goods_sales || row.sales || 0
        };
      });
    },
    getPreviewGoodsList: function getPreviewGoodsList(item, index) {
      var cached = this.previewGoodsMap[index];
      if (cached) return cached;
      if (item && item.params && item.params.source === 'choice') {
        return this.normalizeGoodsRows(item.data || []);
      }
      return [];
    },
    fetchArticlePreview: function fetchArticlePreview(index, item) {
      var _this5 = this;
      if (!item || !item.params) return;
      var auto = item.params.auto || {};
      var query = {
        page: 1,
        limit: auto.showNum || 6,
        keywords: ''
      };
      if (auto.category && Number(auto.category) > 0) {
        query.cid = Number(auto.category);
      } else {
        query.cid = '';
      }
      (0, _article.ListArticle)(query).then(function (res) {
        var list = res && Array.isArray(res.recordList) ? res.recordList : [];
        _this5.$set(_this5.previewArticleMap, index, _this5.normalizeArticleRows(list));
      }).catch(function () {
        _this5.$set(_this5.previewArticleMap, index, _this5.normalizeArticleRows(item.data || item.defaultData || []));
      });
    },
    getPreviewArticleList: function getPreviewArticleList(item) {
      var index = this.data && Array.isArray(this.data.items) ? this.data.items.indexOf(item) : -1;
      var cached = index > -1 ? this.previewArticleMap[index] : null;
      var source = cached ? cached : item && Array.isArray(item.data) && item.data.length ? item.data : [];
      return this.normalizeArticleRows(source);
    },
    normalizeArticleRows: function normalizeArticleRows() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return source.map(function (row) {
        return {
          title: row.title || '',
          show_type: row.show_type || row.showType || 10,
          image: row.image || row.image_url || row.imageInput || row.frontCoverUrl || '',
          views_num: row.views_num || row.show_views || row.visit || 0,
          category: row.category || (row.categoryName ? {
            name: row.categoryName
          } : null)
        };
      });
    }
  }
};